import { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { numberFormatter } from '@dnhb/formatters';

const lineheightFix = {
  '&::before': {
    content: "''",
    display: 'block',
    height: 0,
    width: 0,
    marginTop: 'calc(-0.325 * 0.5em)',
  },
  '&::after': {
    content: "''",
    display: 'block',
    height: 0,
    width: 0,
    marginBottom: 'calc(-0.2 * 0.5em)',
  },
};
const PercentageContainer = styled.span(props => ({
  display: 'inline-flex',
  alignItems: 'flex-start',
  fontWeight: props.fontWeight ? props.fontWeight : '600',
}));

const PostFix = styled.span(props => {
  const fontSize = props.fontSize
    ? `${props.fontSize}px`
    : props.styleRef &&
      props.styleRef.current &&
      window.getComputedStyle(props.styleRef.current).getPropertyValue('font-size');
  return {
    color: props.theme.highlightColor,
    fontSize: parseInt(fontSize) <= 18 || props.disableFontSizeLimitOfPrefix ? fontSize : '18px',
    marginLeft: '2px',
    lineHeight: 1,
    ...lineheightFix,
  };
});

const Value = styled.span(props => {
  return {
    color: props.theme.primaryColor,
    fontSize: props.fontSize ? `${parseInt(props.fontSize)}px` : 'inherit',
    lineHeight: 1,
    ...lineheightFix,
  };
});

const Percentage = ({ value, decimals, alwaysShowDecimals, ...props }) => {
  const styleRef = useRef();
  return (
    <span ref={styleRef}>
      <PercentageContainer {...props}>
        <Value {...props}>{numberFormatter(value, decimals, alwaysShowDecimals)}</Value>
        <PostFix {...props} styleRef={styleRef}>%</PostFix>
      </PercentageContainer>
    </span>
  );
};

Percentage.propTypes = {
  value: PropTypes.number.isRequired,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  decimals: PropTypes.number,
  alwaysShowDecimals: PropTypes.bool,
  disableFontSizeLimitOfPrefix: PropTypes.bool,
};

Percentage.defaultProps = {
  fontSize: '',
  fontWeight: '600',
  decimals: 2,
  alwaysShowDecimals: false,
  disableFontSizeLimitOfPrefix: false,
};

export default Percentage;
